import { render, staticRenderFns } from "./okao-photo-list.vue?vue&type=template&id=63cff55c&scoped=true&lang=pug&"
import script from "./okao-photo-list.vue?vue&type=script&lang=js&"
export * from "./okao-photo-list.vue?vue&type=script&lang=js&"
import style0 from "./okao-photo-list.vue?vue&type=style&index=0&id=63cff55c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cff55c",
  null
  
)

export default component.exports